/* unplugin-vue-components disabled */import { render } from "./member_fxdetails_m.vue?vue&type=template&id=c73f372c&scoped=true"
import script from "./member_fxdetails_m.vue?vue&type=script&lang=js"
export * from "./member_fxdetails_m.vue?vue&type=script&lang=js"

import "./member_fxdetails_m.vue?vue&type=style&index=0&id=c73f372c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c73f372c"]])

export default __exports__